module.exports = __webpack_public_path__ + "static/media/logo_azul.2fc61395.svg";